/**
 * Public Firebase Cloud Messaging web config.
 *
 * Every value here is a *public* client credential supplied by the connected
 * Firebase project. The service account never reaches the browser — sends go
 * through the server-side connector gateway.
 *
 * `messagingSenderId` has no variable of its own: it is the second segment of
 * the app id (`1:<senderId>:web:<hash>`). Omitting it makes getMessaging throw
 * `messaging/missing-app-config-values`.
 */
const appId = import.meta.env["VITE_LOVABLE_CONNECTOR_FIREBASE_MESSAGING_APP_ID"] as
  | string
  | undefined;

export const FCM_VAPID_KEY = (import.meta.env[
  "VITE_LOVABLE_CONNECTOR_FIREBASE_MESSAGING_VAPID_KEY"
] ?? "") as string;

export const FCM_WEB_CONFIG = {
  apiKey: (import.meta.env["VITE_LOVABLE_CONNECTOR_FIREBASE_MESSAGING_WEB_API_KEY"] ?? "") as string,
  projectId: (import.meta.env["VITE_LOVABLE_CONNECTOR_FIREBASE_MESSAGING_PROJECT_ID"] ?? "") as string,
  appId: appId ?? "",
  messagingSenderId: appId?.split(":")[1] ?? "",
};

/** True when the browser has everything it needs to mint a Firebase token. */
export function isFcmConfigured(): boolean {
  return Boolean(
    FCM_WEB_CONFIG.apiKey &&
      FCM_WEB_CONFIG.projectId &&
      FCM_WEB_CONFIG.appId &&
      FCM_WEB_CONFIG.messagingSenderId &&
      FCM_VAPID_KEY,
  );
}

/** Query string handed to the messaging worker (it cannot read import.meta.env). */
export function fcmSwQuery(): string {
  return new URLSearchParams(FCM_WEB_CONFIG).toString();
}
